<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>行前指导调查</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="selClick"
      >
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="角色/建议/答卷关键词" clearable></el-input>
        </el-form-item>
        <SelectAbroad
          label="赴日时间"
          v-on:selabroad="onAbroadSel"
        ></SelectAbroad>
        <el-form-item>
          <el-button type="primary" @click="selClick">查询</el-button>
          <el-button type="success" :loading="exporting" @click="exportClick">导出Excel</el-button>
          <el-button type="warning" plain @click="openQuestionConfig">题目配置</el-button>
        </el-form-item>
      </el-form>

      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>{{ surveyTitle || '行前指导调查' }}列表</span>
        </div>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="userCode" label="用户编号" width="110" fixed></el-table-column>
          <el-table-column prop="nickName" label="昵称" min-width="90"></el-table-column>
          <el-table-column prop="realName" label="姓名" width="90"></el-table-column>
          <el-table-column prop="mobile" label="手机" width="120"></el-table-column>
          <el-table-column prop="roleName" label="角色" width="80"></el-table-column>
          <el-table-column label="赴日时间" width="100">
            <template slot-scope="scope">{{ scope.row.abroadDateText || '-' }}</template>
          </el-table-column>
          <!-- 按当前题目配置动态列；历史答卷若无该 key 则空，详情/其它列仍可看旧题 -->
          <el-table-column
            v-for="col in listQuestionColumns"
            :key="'qcol-' + col.key"
            :label="col.title"
            min-width="120"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ answerCellText(scope.row, col.key) }}
            </template>
          </el-table-column>
          <el-table-column
            label="其它/历史答卷"
            min-width="160"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ otherAnswersText(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="提交时间" width="160"></el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="查看" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    plain
                    icon="el-icon-view"
                    @click="viewClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="mini"
                    plain
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 题目配置（从系统设置迁到本页，方便查找） -->
    <el-dialog
      title="调查题目配置"
      :visible.sync="questionDialogVisible"
      width="960px"
      top="5vh"
      :close-on-click-modal="false"
    >
      <el-alert
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom:14px"
        title="修改后保存即对小程序生效。改题不影响库里旧答卷：提交时已固化 questionMeta，详情/导出/「其它历史答卷」仍按当时题目展示。勿改已有题的 key，否则列表本期列会对不上旧答案。"
      ></el-alert>
      <el-form label-width="100px" size="small">
        <el-form-item label="入口展示名">
          <el-input v-model="editSurveyTitle" placeholder="行前指导调查" style="max-width:360px"></el-input>
          <div style="color:#909399;font-size:12px;margin-top:4px">VIP专属第二个入口的名称</div>
        </el-form-item>
        <el-form-item label="题目列表">
          <div style="margin-bottom:8px">
            <el-button size="mini" type="primary" @click="addSuggestQuestion">新增题目</el-button>
            <el-button size="mini" @click="resetSuggestQuestions">恢复默认4题</el-button>
          </div>
          <el-table :data="suggestQuestions" border size="mini" style="width:100%">
            <el-table-column label="排序" width="70">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.sort" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="标识key" width="110">
              <template slot-scope="scope">
                <el-input v-model="scope.row.key" size="mini" placeholder="英文key"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="题目标题" min-width="160">
              <template slot-scope="scope">
                <el-input v-model="scope.row.title" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="120">
              <template slot-scope="scope">
                <el-select v-model="scope.row.type" size="mini" style="width:100%">
                  <el-option label="单选" value="select"></el-option>
                  <el-option label="多选" value="multi"></el-option>
                  <el-option label="单行输入" value="input"></el-option>
                  <el-option label="多行输入" value="textarea"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="选项(逗号分隔)" min-width="180">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.options"
                  size="mini"
                  :disabled="scope.row.type==='input' || scope.row.type==='textarea'"
                  placeholder="需要,不需要,待定"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="必填" width="70" align="center">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.required"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="70" align="center">
              <template slot-scope="scope">
                <el-button type="text" style="color:#f56c6c" @click="removeSuggestQuestion(scope.$index)">删</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="questionDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="questionSaving" @click="saveQuestionConfig">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="(surveyTitle || '调查') + '详情'"
      :visible.sync="dialogVisible"
      width="820px"
      top="5vh"
      :close-on-click-modal="false"
      custom-class="suggest-detail-dialog"
    >
      <div class="detail-section">
        <div class="section-title">
          <i class="el-icon-user"></i>
          基本信息
        </div>
        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-label">用户编号</div>
            <div class="detail-value">{{ form.userCode || "-" }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">昵称</div>
            <div class="detail-value">{{ form.nickName || "-" }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">姓名</div>
            <div class="detail-value">{{ form.realName || "-" }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">手机</div>
            <div class="detail-value">{{ form.mobile || "-" }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">角色</div>
            <div class="detail-value">
              <el-tag size="small" type="success">{{ form.roleName || "-" }}</el-tag>
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">赴日时间</div>
            <div class="detail-value">{{ form.abroadDateText || "-" }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">提交时间</div>
            <div class="detail-value">{{ form.createTime || "-" }}</div>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <div class="section-title">
          <i class="el-icon-document"></i>
          答卷内容
        </div>
        <div v-if="answerRows.length" class="qa-list">
          <div v-for="(item, idx) in answerRows" :key="idx" class="qa-item">
            <div class="qa-label">
              <span class="qa-index">{{ idx + 1 }}</span>
              {{ item.label }}
            </div>
            <div class="qa-value">
              <template v-if="item.tags && item.tags.length">
                <el-tag
                  v-for="(t, ti) in item.tags"
                  :key="ti"
                  size="small"
                  type="info"
                  class="qa-tag"
                >{{ t }}</el-tag>
              </template>
              <div v-else class="qa-text">{{ item.value || "-" }}</div>
            </div>
          </div>
        </div>
        <div v-else class="empty-tip">暂无答卷明细</div>
      </div>

      <div class="detail-section" v-if="form.attractPoint || form.suggestText">
        <div class="section-title">
          <i class="el-icon-chat-dot-round"></i>
          补充说明
        </div>
        <div class="extra-block" v-if="form.attractPoint">
          <div class="extra-label">吸引点</div>
          <div class="extra-text">{{ form.attractPoint }}</div>
        </div>
        <div class="extra-block" v-if="form.suggestText">
          <div class="extra-label">建议内容</div>
          <div class="extra-text">{{ form.suggestText }}</div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import SelectAbroad from "@/components/SelectAbroad";

/** 旧版「建议收集」扁平字段中文名（兼容历史数据） */
var legacyFieldOrder = [
  { key: "reasons", label: "留学原因" },
  { key: "reasonOther", label: "其他留学原因" },
  { key: "purpose", label: "留学目的" },
  { key: "purposeOther", label: "其他目的" },
  { key: "concerns", label: "关心/担心的问题" },
  { key: "concernOther", label: "其他关心问题" },
  { key: "agencyReasons", label: "选择中介的原因" },
  { key: "agencyReasonOther", label: "其他中介原因" },
  { key: "agencyFactors", label: "看重的因素" },
  { key: "agencyFactorOther", label: "其他看重因素" }
];

var skipKeys = {
  reasonList: 1,
  purposeList: 1,
  concernList: 1,
  agencyReasonList: 1,
  agencyFactorList: 1,
  roleOptions: 1,
  purposeOptions: 1,
  roleOpt: 1,
  submitting: 1,
  submitUserInfo: 1,
  attractPoint: 1,
  suggestText: 1,
  role: 1,
  answers: 1,
  questionMeta: 1
};

export default {
  components: { SelectAbroad },
  data() {
    return {
      key: "",
      abroadTime: "",
      loading: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      dialogVisible: false,
      form: {},
      answerRows: [],
      questionTitleMap: {},
      questionOrder: [],
      surveyTitle: "行前指导调查",
      exporting: false,
      questionDialogVisible: false,
      questionSaving: false,
      editSurveyTitle: "",
      siteConfig: null,
      suggestQuestions: [],
      defaultSuggestQuestions: [
        { key: "rent", title: "租房意向", type: "select", options: "需要,不需要,待定", required: true, sort: 1 },
        { key: "sim", title: "手机卡意向", type: "select", options: "需要,不需要,待定", required: true, sort: 2 },
        { key: "visaAgency", title: "签证代签意向", type: "select", options: "需要,不需要,待定", required: true, sort: 3 },
        { key: "groupDepart", title: "团体赴日报名意向", type: "select", options: "有意向,无意向,待定", required: true, sort: 4 }
      ]
    };
  },
  computed: {
    /** 列表动态列 = 当前后台题目配置 */
    listQuestionColumns() {
      var map = this.questionTitleMap || {};
      return (this.questionOrder || []).map(function (k) {
        return { key: k, title: map[k] || k };
      });
    }
  },
  mounted() {
    this.loadQuestionMeta();
    this.getList();
  },
  methods: {
    api(action) {
      return url.getMiniManage(action);
    },
    parseSuggestQuestions(json) {
      try {
        var list = JSON.parse(json || "[]");
        if (!Array.isArray(list) || list.length === 0) return this.defaultSuggestQuestions.slice();
        return list.map(function (q, i) {
          return {
            key: q.key || ("q" + (i + 1)),
            title: q.title || "",
            type: q.type || "select",
            options: q.options || "",
            required: q.required !== false,
            sort: q.sort != null ? q.sort : i + 1
          };
        });
      } catch (e) {
        return this.defaultSuggestQuestions.slice();
      }
    },
    applyQuestionMetaFromList(questions, title) {
      var map = {};
      var order = [];
      (questions || []).forEach(function (q) {
        if (!q || !q.key) return;
        map[q.key] = q.title || q.key;
        order.push(q.key);
      });
      legacyFieldOrder.forEach(function (f) {
        if (!map[f.key]) map[f.key] = f.label;
      });
      this.questionTitleMap = map;
      this.questionOrder = order;
      if (title) this.surveyTitle = title;
    },
    loadQuestionMeta() {
      var _this = this;
      $.get(_this.api("GetSuggestQuestionMeta"), {}, function (res) {
        _this.applyQuestionMetaFromList(res.questions || [], res.title);
      });
    },
    openQuestionConfig() {
      var _this = this;
      $.get(url.getSys("getconfig"), {}, function (data) {
        _this.siteConfig = data || {};
        _this.editSurveyTitle = data.vipMenuSuggest || _this.surveyTitle || "行前指导调查";
        _this.suggestQuestions = _this.parseSuggestQuestions(data.suggestQuestionsJson);
        _this.questionDialogVisible = true;
      });
    },
    addSuggestQuestion() {
      this.suggestQuestions.push({
        key: "q" + (this.suggestQuestions.length + 1),
        title: "",
        type: "select",
        options: "需要,不需要,待定",
        required: true,
        sort: this.suggestQuestions.length + 1
      });
    },
    removeSuggestQuestion(index) {
      this.suggestQuestions.splice(index, 1);
    },
    resetSuggestQuestions() {
      this.suggestQuestions = this.defaultSuggestQuestions.map(function (q) {
        return Object.assign({}, q);
      });
    },
    saveQuestionConfig() {
      var _this = this;
      var list = this.suggestQuestions || [];
      for (var i = 0; i < list.length; i++) {
        if (!list[i].key || !list[i].title) {
          this.$message.warning("请填写完整的标识 key 和题目标题");
          return;
        }
      }
      if (!this.siteConfig) {
        this.$message.error("配置未加载，请关闭后重试");
        return;
      }
      this.questionSaving = true;
      var info = Object.assign({}, this.siteConfig);
      info.vipMenuSuggest = (this.editSurveyTitle || "").trim() || "行前指导调查";
      info.suggestQuestionsJson = JSON.stringify(list);
      $.post(url.getSys("saveconfig"), info, function (res) {
        _this.questionSaving = false;
        if (res && res.status) {
          _this.$message.success(res.msg || "保存成功");
          _this.questionDialogVisible = false;
          _this.surveyTitle = info.vipMenuSuggest;
          _this.applyQuestionMetaFromList(list, info.vipMenuSuggest);
          _this.siteConfig = info;
        } else {
          _this.$message.error((res && res.msg) || "保存失败");
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    /** 与 VIP 列表 SelectAbroad 一致：选年月后立即查询 */
    onAbroadSel(str) {
      this.abroadTime = str || "";
      this.selClick();
    },
    selClick() {
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      var _this = this;
      _this.loading = true;
      $.get(
        _this.api("GetList_Suggest"),
        {
          key: _this.key,
          abroadTime: _this.abroadTime || "",
          pageindex: _this.currentPage,
          pagesize: _this.pageSize
        },
        function (data) {
          _this.loading = false;
          _this.tableData = data.list || [];
          _this.total = data.total || 0;
        }
      );
    },
    isJunkKey(k) {
      if (!k) return true;
      if (k.indexOf("__") === 0) return true;
      if (k.indexOf("show") === 0) return true;
      if (skipKeys[k]) return true;
      if (/List$/i.test(k) || /Options$/i.test(k) || /Opt$/i.test(k)) return true;
      return false;
    },
    formatValue(v) {
      if (v == null || v === "") return { value: "-", tags: null };
      if (Object.prototype.toString.call(v) === "[object Array]") {
        var tags = v
          .map(function (x) {
            if (x == null) return "";
            if (typeof x === "object") {
              return x.text || x.label || x.value || x.name || "";
            }
            return String(x);
          })
          .filter(function (x) {
            return x;
          });
        return { value: tags.join("；"), tags: tags };
      }
      if (typeof v === "object") {
        var t = v.text || v.label || v.value || v.name;
        if (t) return { value: String(t), tags: null };
        return { value: JSON.stringify(v), tags: null };
      }
      if (typeof v === "boolean") return { value: v ? "是" : "否", tags: null };
      return { value: String(v), tags: null };
    },
    /** 解析答卷：优先 answers 嵌套；兼容旧扁平结构 */
    parseAnswerPayload(answerJson) {
      if (!answerJson) return { answers: {}, metaMap: {} };
      var obj;
      try {
        obj = typeof answerJson === "string" ? JSON.parse(answerJson) : answerJson;
      } catch (e) {
        return { answers: null, raw: answerJson, metaMap: {} };
      }
      if (!obj || typeof obj !== "object") return { answers: {}, metaMap: {} };

      var metaMap = {};
      (obj.questionMeta || obj.QuestionMeta || []).forEach(function (m) {
        if (m && m.key) metaMap[m.key] = m.title || m.key;
      });

      var answers = {};
      if (obj.answers && typeof obj.answers === "object" && !Array.isArray(obj.answers)) {
        answers = obj.answers;
      } else {
        Object.keys(obj).forEach(function (k) {
          if (skipKeys[k] || k === "questionMeta" || k === "QuestionMeta") return;
          answers[k] = obj[k];
        });
      }
      return { answers: answers, metaMap: metaMap };
    },
    resolveLabel(key, metaMap) {
      if (metaMap && metaMap[key]) return metaMap[key];
      if (this.questionTitleMap && this.questionTitleMap[key]) return this.questionTitleMap[key];
      var legacy = legacyFieldOrder.find(function (f) {
        return f.key === key;
      });
      if (legacy) return legacy.label;
      return key;
    },
    /** 列表单元格：取当前配置题对应答案（无则空） */
    answerCellText(row, key) {
      var parsed = this.parseAnswerPayload(row && row.answerJson);
      if (!parsed.answers) return "";
      var fv = this.formatValue(parsed.answers[key]);
      return fv.value === "-" ? "" : fv.value;
    },
    /**
     * 非本期配置的题（改题后的历史 key）：用提交时固化的标题拼摘要，
     * 保证下期换题后旧数据在列表仍可见，点详情可看完整 Q&A。
     */
    otherAnswersText(row) {
      var parsed = this.parseAnswerPayload(row && row.answerJson);
      if (!parsed.answers) return "";
      var current = {};
      (this.questionOrder || []).forEach(function (k) {
        current[k] = 1;
      });
      var parts = [];
      var answers = parsed.answers;
      var metaMap = parsed.metaMap || {};
      Object.keys(answers).forEach(
        function (k) {
          if (current[k] || this.isJunkKey(k)) return;
          var fv = this.formatValue(answers[k]);
          if (fv.value === "-") return;
          parts.push(this.resolveLabel(k, metaMap) + "：" + fv.value);
        }.bind(this)
      );
      // 兼容旧字段吸引点/建议（非 answerJson 内）
      if (row && row.attractPoint) parts.push("吸引点：" + row.attractPoint);
      if (row && row.suggestText) parts.push("建议：" + row.suggestText);
      return parts.join("；");
    },
    buildAnswerRows(answerJson) {
      var parsed = this.parseAnswerPayload(answerJson);
      if (parsed.raw) {
        return [{ label: "原始答卷", value: parsed.raw, tags: null }];
      }
      var answers = parsed.answers || {};
      var metaMap = parsed.metaMap || {};
      var rows = [];
      var used = {};

      // 1) 当前后台题目顺序
      (this.questionOrder || []).forEach(function (k) {
        if (answers[k] === undefined || answers[k] === null || answers[k] === "") return;
        used[k] = 1;
        var fv = this.formatValue(answers[k]);
        rows.push({ label: this.resolveLabel(k, metaMap), value: fv.value, tags: fv.tags });
      }.bind(this));

      // 2) 旧版建议收集字段顺序
      legacyFieldOrder.forEach(function (f) {
        if (used[f.key]) return;
        if (answers[f.key] === undefined || answers[f.key] === null || answers[f.key] === "") return;
        used[f.key] = 1;
        var fv = this.formatValue(answers[f.key]);
        rows.push({ label: f.label, value: fv.value, tags: fv.tags });
      }.bind(this));

      // 3) 其余历史 key（题目已删仍展示，标题优先用提交时固化的 meta）
      Object.keys(answers).forEach(function (k) {
        if (used[k] || this.isJunkKey(k)) return;
        var fv = this.formatValue(answers[k]);
        if (fv.value === "-") return;
        rows.push({ label: this.resolveLabel(k, metaMap), value: fv.value, tags: fv.tags });
      }.bind(this));

      return rows;
    },
    viewClick(row) {
      var _this = this;
      $.get(_this.api("GetModel_Suggest"), { id: row.id }, function (data) {
        _this.form = data || {};
        _this.answerRows = _this.buildAnswerRows(data && data.answerJson);
        _this.dialogVisible = true;
      });
    },
    exportClick() {
      var _this = this;
      _this.exporting = true;
      var link = _this.api("Export_Suggest")
        + "?key=" + encodeURIComponent(_this.key || "")
        + "&abroadTime=" + encodeURIComponent(_this.abroadTime || "");
      // 带登录态：用 xhr blob 下载
      var xhr = new XMLHttpRequest();
      xhr.open("GET", link, true);
      xhr.responseType = "blob";
      xhr.withCredentials = true;
      xhr.onload = function () {
        _this.exporting = false;
        if (xhr.status !== 200) {
          _this.$message.error("导出失败");
          return;
        }
        var blob = xhr.response;
        var a = document.createElement("a");
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = (_this.surveyTitle || "行前指导调查") + ".xls";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      };
      xhr.onerror = function () {
        _this.exporting = false;
        _this.$message.error("导出失败");
      };
      xhr.send();
    },
    delClick(row) {
      var _this = this;
      this.$confirm("确定删除该条调查答卷吗？", "提示", {
        type: "warning"
      })
        .then(function () {
          $.post(_this.api("Delete_Suggest"), { id: row.id }, function (res) {
            if (res.status) {
              _this.$message.success(res.msg || "删除成功");
              _this.getList();
            } else {
              _this.$message.error(res.msg || "删除失败");
            }
          });
        })
        .catch(function () {});
    }
  }
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding: 18px 16px 2px;
  background: #f2f2f2;
}
.detail-section {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 16px 18px 8px;
  margin-bottom: 14px;
}
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
}
.section-title i {
  margin-right: 6px;
  color: #409eff;
}
.detail-grid {
  display: flex;
  flex-wrap: wrap;
}
.detail-item {
  width: 33.33%;
  box-sizing: border-box;
  padding: 0 12px 14px 0;
}
.detail-label {
  color: #909399;
  font-size: 12px;
  margin-bottom: 4px;
}
.detail-value {
  color: #303133;
  font-size: 14px;
  word-break: break-all;
}
.qa-list {
  padding-bottom: 6px;
}
.qa-item {
  padding: 12px 0;
  border-bottom: 1px dashed #ebeef5;
}
.qa-item:last-child {
  border-bottom: none;
}
.qa-label {
  color: #606266;
  font-size: 13px;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
  line-height: 1.5;
}
.qa-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-right: 8px;
  margin-top: 1px;
  border-radius: 50%;
  background: #ecf5ff;
  color: #409eff;
  font-size: 12px;
  flex-shrink: 0;
}
.qa-value {
  padding-left: 26px;
}
.qa-text {
  color: #303133;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}
.qa-tag {
  margin: 0 8px 8px 0;
  max-width: 100%;
  height: auto;
  white-space: normal;
  line-height: 1.4;
  padding: 4px 8px;
}
.extra-block {
  margin-bottom: 12px;
}
.extra-label {
  color: #909399;
  font-size: 12px;
  margin-bottom: 6px;
}
.extra-text {
  background: #f8f9fc;
  border-radius: 4px;
  padding: 10px 12px;
  line-height: 1.6;
  white-space: pre-wrap;
  color: #303133;
}
.empty-tip {
  color: #c0c4cc;
  padding: 12px 0 16px;
  text-align: center;
}
</style>
